import { Button, Input, Clipboard } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import {
  useRecoilValue,
  useRecoilState,
  useSetRecoilState,
  useResetRecoilState,
} from 'recoil'
import {
  selectedItemAtom,
  showPinturaAtom,
  itemSelector,
  itemAtomFamily,
  itemsLockedAtom,
  unsavedChangesAtom,
} from 'atoms'
import { useDuplicateItem } from 'hooks'
import { LockAsset } from 'components/editor/PropertiesMenu/LockAsset'
import { MaintainAspectRatio } from 'components/editor/PropertiesMenu/MaintainAspectRatio'
import { HideInPdf } from '@/components/editor/PropertiesMenu/HideInPdf'
import { useTranslation } from 'react-i18next'
import { useItemResize } from '@/hooks/editor/useItemResize'

export const ImageDrawer = () => {
  const { t } = useTranslation()
  const selectedItem = useRecoilValue(selectedItemAtom)
  const itemsLocked = useRecoilValue(itemsLockedAtom)

  const duplicateItem = useDuplicateItem()

  // Use shared resize hook for width/height management
  const { width, height, setWidthSize, setHeightSize } =
    useItemResize(selectedItem)

  const [circle, setCircle] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.circle' }),
  )
  const resetItem = useResetRecoilState(itemAtomFamily(selectedItem))
  const setUnsavedChanges = useSetRecoilState(unsavedChangesAtom)
  const deleteItem = () => {
    resetItem()
    setUnsavedChanges(true)
  }
  const setShowPintura = useSetRecoilState(showPinturaAtom)

  const toggleShape = (shape) => setCircle(shape === 'circle')
  const showPinturaModal = () => setShowPintura(true)

  const roundedWidth = Math.round(width)
  const roundedHeight = Math.round(height)

  return (
    <Flex column padding="0 12px">
      <Button
        center
        margin="0 0 16px"
        onClick={duplicateItem}
        disabled={itemsLocked}
      >
        {t('editor.menus.properties.elements.imageDrawer.duplicateImageButton')}
      </Button>
      <Button center margin="0 0 16px" onClick={deleteItem}>
        {t('editor.menus.properties.elements.imageDrawer.deleteImageButton')}
      </Button>
      <Button center margin="0 0 16px" onClick={showPinturaModal}>
        {t('editor.menus.properties.elements.imageDrawer.adjustImageButton')}
      </Button>
      <Clipboard />
      <LockAsset selectedItem={selectedItem} />
      <MaintainAspectRatio selectedItem={selectedItem} />
      <HideInPdf selectedItem={selectedItem} />
      <Text margin="0 0 16px">
        {t('editor.menus.properties.elements.imageDrawer.sizeText')}
      </Text>
      <Flex margin="0 0 24px">
        <Input
          value={[roundedWidth, setWidthSize]}
          label={t('editor.menus.properties.elements.imageDrawer.widthLabel')}
          margin="0 16px 0 0"
          type="number"
          disabled={itemsLocked}
        />
        <Input
          value={[roundedHeight, setHeightSize]}
          label={t('editor.menus.properties.elements.imageDrawer.heightLabel')}
          type="number"
          disabled={itemsLocked}
        />
      </Flex>
      <Flex column margin="0 0 16px">
        <Text margin="0 0 16px">
          {t('editor.menus.properties.elements.imageDrawer.shapeText')}
        </Text>
        <Flex>
          <Button
            width="42px"
            height="42px"
            padding="0 0 0 4px"
            margin="4px"
            icon="editorSquareImage"
            disabled={!circle}
            onClick={() => toggleShape('square')}
          />
          <Button
            width="42px"
            height="42px"
            padding="0 0 0 4px"
            margin="4px"
            icon="editorOvalImage"
            disabled={circle}
            onClick={() => toggleShape('circle')}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default ImageDrawer
